import { render, staticRenderFns } from "./preview_4.vue?vue&type=template&id=af940118&scoped=true"
import script from "./preview_4.vue?vue&type=script&lang=js"
export * from "./preview_4.vue?vue&type=script&lang=js"
import style0 from "./preview_4.vue?vue&type=style&index=0&id=af940118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af940118",
  null
  
)

export default component.exports